import { Route, Routes } from "react-router-dom";

import AllLeads from "./AllLeads/AllLeads";
import Labels from "./Labels";
import LeadDetails from "./LeadDetails";

export default function Leads() {
  return (
    <Routes>
      <Route path="/" element={<AllLeads />} />
      <Route path="/labels" element={<Labels />} />
      <Route path="/:profileId" element={<LeadDetails />} />
    </Routes>
  );
}
